// extracted by mini-css-extract-plugin
export default {"info":"IconRender_info__xB+GM"};